import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Resolve the Mapbox token from the build-time env (preview) OR, when that isn't
// baked into the bundle (e.g. production), fetch it once from the backend at
// runtime. Cached module-wide so it's fetched at most once per session.
let cached = process.env.REACT_APP_MAPBOX_TOKEN || null;
let inflight = null;

export function useMapboxToken() {
  const [token, setToken] = useState(cached);
  useEffect(() => {
    if (token) return;
    if (!inflight) {
      inflight = api
        .get("/config/public")
        .then((r) => {
          cached = r.data?.mapbox_token || null;
          return cached;
        })
        .catch(() => null);
    }
    inflight.then((t) => { if (t) setToken(t); });
  }, [token]);
  return token;
}
